import styled from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';

// material ui
import TextField from '@material-ui/core/TextField';
import {
    Button, Card as MuiCard, CardContent, Link, Grid, Tabs, Tab, AppBar,
  IconButton, FormControlLabel, CardHeader, Select, Container, FormControl,
  Typography,
  ListItemText,
  createStyles,
  TableCell
} from '@material-ui/core';


// Styled login components ....
export const ViewGrid = styled(Grid)`
    margin: 2px 2px 27px 2px;
    overflow: auto;
`;

export const TopMarginGrid = styled(Grid)`
    margin: 100px 0 0 0;
`;

export const StyledDiv = styled.div`
    margin-top: 64px;
    display: flex;
    flex-direction: column;
    align-items: center;

    @media (max-width: 768px) {
        margin-top: 0px;
    }
`;

export const StyledCard = styled(MuiCard)`    
    width: 500px;

    @media (max-width: 768px) {
        height: 100vh;
        width: 100vw;
    }
`;

export const StyledContainer = styled(Container).attrs({ component: 'main' })`
    @media (min-width: 769px) {
        margin-top: 125px;
    }
`;

export const StyledCardContent = styled(CardContent)`
    padding: 0 16px;
`;

export const ButtonGrid = styled(Grid)`
    display: inline;
`;

export const IndentGrid = styled(Grid)`
    margin: 0 8px 8px 4px;
    > .MuiGrid-item {
      padding-top: 0 !important;
      padding-bottom: 0 !important;
    }
`;

export const IndentGrid2 = styled(Grid)`

    margin: 0 8px 0 20px;
    > .MuiGrid-item {
      padding-top: 0 !important;
      padding-bottom: 0 !important;
    }
    
`;

export const StyledCancelLink = styled(Link).attrs({ component: RouterLink, to: "/" })`
    color: ${props => props.theme.palette.warning.main};
    font-weight: 600;
    font-size: 1.085em;
`;

export const StyledForgotPasswordSubmission = styled(Link).attrs({ component: RouterLink, to: "/" })`
    font-weight: 600;
    font-size: 1.085em;
     `;

export const AttachmentsLink = styled(Link).attrs({ component: RouterLink, to: "/" })`
    
     `;

export const StyledCancelButton = styled(Button)`
    margin: 24px 0 16px;
    color: ${props => props.theme.palette.warning.main};
    float: right;
    font-weight: 600;
    font-size: 1.4em;
`;

export const StyledSubmitButton = styled(Button)`
    margin: 24px 0 16px;
    float: right;
    font-weight: 700;
    font-size: 1.4em;
`;

export const StyledForm = styled.form`
    width: 100%;
    margin-top: 8px;
`;
export const StyledOptionForm = styled.form`
    width: 100%;
`;

export const StyledTextField = styled(TextField)`
    margin-top: 12px;
`;

export const ClearAppBar = styled(AppBar)`
    background-color: #fff;
    margin: 4px 0;
`;

export const BottomAppBar = styled(AppBar)`
    background-color: ${props => props.theme.palette.grey[50]};
    top: auto;
    bottom: 0;
`;

export const BottomCancelButton = styled(Button)`
    margin: 8px 0;
    float: right;
    font-weight: 700;
    color: ${props => props.theme.palette.secondary.main};
    font-size: 1.075em;
`;

export const BottomSaveButton = styled(Button)`
    margin: 8px 24px;
    float: right;
    font-weight: 700;
    font-size: 1.075em;
    color: ${props => props.theme.palette.secondary.main};
`;

export const StyledTabs = styled(Tabs)`
    padding: 0 32px;
    border-bottom: 1px solid #e8e8e8;
    color: gray;
`;

export const StyledTab = styled(Tab)`
    min-width: 72px;
    //font-size: 1.22em;
    &:hover {
      color: #40a9ff;
      opacity: 1;
    }
    &.Mui-selected {
      color: ${props => props.theme.palette.primary.main};
      font-weight: 600;
    }
    
`;

export const DenseTableCell = styled(TableCell)`
    padding: 5px;
`;

export const Subtitle = styled.h4`
    margin: 1px;
`;

export const LargeIconButton = styled(IconButton)`
    float: right;
    margin-top: 8px;
    margin-bottom: 8px;
    padding: 0;
    > span {
      > svg   {
          width: 2.25rem;
          height: 2.25rem;
        }
    }  
`;

export const EndIconButton = styled(IconButton)`
    
    margin-top: 8px;
    margin-bottom: 8px;
    padding: 0;
    > span {
     > svg   {
          width: 2.25rem;
          height: 2.25rem;
        }
    }  
`;

export const Icon = styled(IconButton)`
    float: right;
`;

export const MarginTopIcon = styled(IconButton)`
    margin-top: 80px;
    float: right;
`;

export const SmallIcon = styled(IconButton)`
   
`;

export const EndButton = styled(Button)`
    float: right;
    margin-top: 8px;
    margin-bottom: 8px;
`;



// export const LargeIconButton = styled(IconButton)`
//     float: right;
//     padding: 0;
//     > span {
//       > svg   {
//           width: 2.25rem;
//           height: 2.25rem;
//         }
//     }  
// `;

export const Checkbox1 = styled(FormControlLabel)`
    margin-top: 12px;
`;

export const Checkbox2 = styled(FormControlLabel)`
    margin-top: 1px;
`;

export const Checkbox3 = styled(FormControlLabel)`
    
    margin-top: 12px;
`;

export const CardCheckbox = styled(FormControlLabel)`
    margin-top: -4px;
    float: right;
    > span {
      padding: 0;
    }
`;

export const TableCard = styled(MuiCard)`   
    width: 100%;
    padding: 2px;
    margin-bottom: 16px;
    //&:hover {
    //    cursor: pointer;
    //}
`;

export const SwitchControl = styled(FormControlLabel)`
    margin-top: -4px;
    float: right;
`;

export const CardContent1 = styled(CardContent)`
    padding: 8px;
    padding-bottom: 8px !important;
`;

export const CardImage = styled(CardContent)`
    padding: 8px;
    position: relative;
    min-height: 96px;
`;

export const CardHeaderDivider = styled(CardHeader)`
    border-bottom: 1px solid #e8e8e8;
`;

export const BoldText = styled.span`
    font-weight: 600;
    color: black;
`;

export const BlackText = styled.span`
    color: black;
`;
export const DarkText = styled.span`
    color: #333333;
`;

export const DashedBox = styled(Grid)`
    border: 2px dashed #cecece;
`;

export const UnderlinedGrid = styled(Grid)`
    border-bottom: 2px solid #b0b0b0;
`;

export const CondensedGrid = styled(Grid)`
    > p {
      margin-bottom: 0;
      margin-top: 0;
    }
`;

export const HeaderSearchTextField = styled(TextField)`
    &.label.Mui-focused {
      color: white;
    }
    &.MuiInput-underline:after {
      borderBottomColor: white;
    }
    &.MuiOutlinedInput-root {
      &:fieldset {
        borderColor: white;
      }
      &:hover fieldset {
        borderColor: white;
      }
      &.Mui-focused fieldset {
        borderColor: white;
      }
}
    width: 135px;
    padding: 5px;
    margin-bottom: 5px;
`;

export const StyledSelect = styled(Select)`
    margin-top: 13px;
`;

export const CloseMobileReport = styled.span`
    position: absolute;
    right: 16px;
    top: 8px;
`;

export const CloseMobileReportGrid = styled(Grid)`
    padding: 16px;
    position: relative;
`;

export const ListContainer = styled.div`  
  padding-left: 24px;
  padding-right: 8px;
`;

export const FlexGrowGrid = styled(Grid)`
  .MuiGrid-root {
    flex-grow: 1;
  }
`;

export const TMGrid = styled(Grid) <{tma: string}>`
  margin-top: ${props => props.tma}px;
`;

export const TMFormControl = styled(FormControl) <{ tma: string }>`
  margin-top: ${props => props.tma}px;
`;

export const ErrorFeedback = styled.small`
  color: #e13023;
`;


// Reports
export const TelerikDiv = styled.div`
    overflow: hidden;
    clear: both;
    > .trv-report-viewer {
        height: calc(100vh - 240px);
    }
`;

export const ReportGrid = styled(Grid)`
    .trv-report-viewer {
        height: calc(50vh - 140px) !important;
    }
`;

export const ListGrid = styled(Grid) <{tma?: string}>`
  background: inherit;
  @media (min-width: 769px) {
    margin-top: ${props => props.tma ?? 20}px;
  }
`;

export const KeyIcon = styled(IconButton) <{ iconcolor?: string }>`
    background-color: ${props => props.iconcolor ?? props.theme.palette.primary.main};
    border-radius: 0;
    font-weight: bold;
    color: snow;
    font-size: 1rem;
    width: 28px;
    height: 28px;

    &:hover {color: ${props => props.theme.palette.text.primary}}
`;

export const FloatingClose = styled.span`
    position: absolute;
    top: -4px;
    right: 4px;
`;

export const NoBorderTextField = styled(TextField)`
    fieldset { border: none; }
    input { padding: 4px; }
`;

export const ContactCardContent = styled(CardContent)`
    padding: 4px;
    padding-bottom: 4px !important;
`;

export const CustomColorLabel = styled(Typography) <{ customcolor?: string }>`
    color: ${props => props.customcolor ? props.customcolor : 'inherit'};
`;

export const ListItemTextButton = styled(ListItemText)`
cursor: pointer;    
`;

export const CenteredText = styled.p`
    text-align: center;    
`;

export const styles: any = createStyles({
    formControlLabel: { fontSize: '0.9rem', 
    '& label': { fontSize: '0.6rem' } },

    listItemText: {
        fontSize: '0.9rem',
    },

    editorWrapper: {
        padding: '1rem',
        border: '1px solid #ccc'
    },
    editor: {
        backgroundColor: 'lightgray',
        padding: '1rem',
        border: '1px solid #ccc'
    },
    editorToolbar: {
        border: '1px solid #ccc'
    }
 });